import React from 'react'
import { FormattedMessage } from 'react-intl'

export const DIALOG_REMOVE_MEMBERS_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.remove_members.title"
        defaultMessage="Исключение из клана"
    />
)

export const DIALOG_REMOVE_MEMBERS_SUBMIT_BUTTON_CAPTION = (
    <FormattedMessage
        id="members_control_block.dialog.remove_members.submit_button.caption"
        defaultMessage="Исключить"
    />
)

export const DIALOG_BUTTON_CANCEL_CAPTION = (
    <FormattedMessage
        id="members_control_block.dialog.button_cancel.caption"
        defaultMessage="Отменить"
    />
)

export const DIALOG_REMOVE_MEMBERS_CONTENT_1_PLAYER = (
    <FormattedMessage
        id="members_control_block.dialog_content.1_player"
        defaultMessage="Исключить из клана игрока"
    />
)

export const DIALOG_REMOVE_MEMBERS_CONTENT_PLAYERS = (
    <FormattedMessage
        id="members_control_block.dialog_content.players"
        defaultMessage="Исключить из клана игроков:"
    />
)

export const DIALOG_CHANGE_COMMANDER_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.change_commander.title"
        defaultMessage="Смена командующего"
    />
)

export const DIALOG_CHANGE_COMMANDER_CONTENT = (
    <FormattedMessage
        id="members_control_block.dialog.change_commander.content"
        defaultMessage="Передать командование игроку"
    />
)

export const DIALOG_CHANGE_COMMANDER_SUBMIT_BUTTON_CAPTION = (
    <FormattedMessage
        id="members_control_block.dialog.change_commander.submit_button.caption"
        defaultMessage="Передать командование"
    />
)



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/translations.js